import { Type } from 'class-transformer';
import { CountryCode, EventCategory, EventStatus } from '../enum';

export class EventListBackofficeDetailDto {
  id: string;
  managementUuid: string;
  status: EventStatus;
  category: EventCategory;
  @Type(() => Date)
  startDate: Date;
  title: string;
  organisers: string[];
  country: CountryCode;
  isShownOnMap: boolean;
  isCentral: boolean;
}

export class EventListBackofficeDto {
  @Type(() => EventListBackofficeDetailDto)
  events: EventListBackofficeDetailDto[];
}
